import React from 'react';
import { services } from '../data/services';
import ServiceSection from '../components/ServiceSection';
import Hero from '../components/Hero';

const Personal = () => {
  return (
    <>
      <Hero
        title="Internet de Mare Viteză pentru Casa Ta"
        subtitle="Conectivitate stabilă și rapidă pentru toată familia ta, cu suport tehnic 24/7"
      >
        <button className="btn-accent text-lg">
          Verifică Acoperirea
        </button>
      </Hero>

      {services.map((service, index) => (
        <ServiceSection key={service.title} service={service} index={index} showPackages={false} />
      ))}
    </>
  );
};

export default Personal;
